



































import { defineComponent } from '@nuxtjs/composition-api';

export default defineComponent({
  name: 'IconRequestQuote',
  props: {
    width: {
      type: String,
      default: '22',
    },
    height: {
      type: String,
      default: '28',
    },
  },
});
